import { render, staticRenderFns } from "./IfStudyGroup.vue?vue&type=template&id=50efcf49&scoped=true&"
import script from "./IfStudyGroup.vue?vue&type=script&lang=js&"
export * from "./IfStudyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efcf49",
  null
  
)

export default component.exports